import { BipV2, LocationV2, PatientV2 } from 'src/app/core/models';

export interface DashboardAdminResponse {
  porcentaje_dt: number;
  num_bips_total_before: number;
  num_bips_total_current: number;
  porcentaje_dp: number;
  bips: {
    data: BipV2[];
  };
  locations: {
    data: LocationV2[];
  };
  total_bips: number;
  total_patients: number;
  total_noteRbts: number;
  total_noteBcbas: number;
  total_employees: number;
  recent_patients: PatientV2[];
  num_bips_current: number;
  num_bips_before: number;
  porcentaje_d: number;
  num_bips_attention_current: number;
  num_bips_attention_before: number;
  porcentaje_da: number;
  num_patients_current: number;
  num_patients_before: number;
  porcentajeDP: number;
}
